export function clickMoveAction({ selectedSquare, square, piece, playerColor }) {
  const isFriendlyPiece = piece && piece.color === playerColor;

  if (!selectedSquare) {
    return {
      selectedSquare: isFriendlyPiece ? square : null,
      move: null,
    };
  }

  if (square === selectedSquare) {
    return { selectedSquare: null, move: null };
  }

  if (isFriendlyPiece) {
    return { selectedSquare: square, move: null };
  }

  return {
    selectedSquare: null,
    move: { from: selectedSquare, to: square },
  };
}
